export default __webpack_public_path__ + "static/images/global-market.70e5beef.png";